// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"80b6ca22","53":"cecca9af","263":"68ccaba7","467":"cee061f6","626":"d94d93fa","728":"ad366d70","787":"b8e5a9a7","824":"4491857a"}[chunkId] + ".chunk.js";
};